import moment from "moment";

export const state = {
  entradaMercadoria: {
    id: "",
    fornecedor_id: "",
    numero_nota: "",
    numero_serie: "",
    cfop: "",
    data_emissao: moment().format("YYYY-MM-DD"),
    data_entrada: moment().format("YYYY-MM-DD"),
    total: "0,00",
    itens: [],
    status: "",
    chave_nfe: "",
    transportadora_id: "",
    valor_frete: "0,00",
    estoque_id: 2,
    modalidade_frete: "FOB",
  },
  entradasMercadorias: {
    data: []
  },
  itensEntradaMercadoria: [],
  contasPagarEntradaMercadoria: [],
  modalExcluirEntradaMercadoria: false,
  modalCadastroEntradaMercadoria: false,
  modalEnviarEmailEntradaMercadoria: false,
};

export default {};
